import {
    CollectionDataLoaded,
    DataLoaderGlobalParams,
    getSearchPublications,
    mapListPublication,
    TopicListingOptions,
} from '@news-mono/web-common'
import { getPublishedSince, getSortOrder } from '../../result-filters'

export interface SearchDataLoaderConfig {
    searchTerm: string
    timeFilter?: string
    sortBy?: string
    topic?: string
    location?: string
    masthead?: string
    options: TopicListingOptions
}

export const MAX_SEARCH_TERM_LENGTH = 150

const emptySearchListing = (): CollectionDataLoaded => ({
    loadMorePossible: false,
    kind: 'listing',
    publications: [],
    total: 0,
})

export const loadSearchData = async (
    props: SearchDataLoaderConfig,
    services: DataLoaderGlobalParams,
): Promise<CollectionDataLoaded> => {
    if (!props.searchTerm || props.searchTerm.length > MAX_SEARCH_TERM_LENGTH) {
        return emptySearchListing()
    }

    let publishedSince: string | undefined = undefined
    let sort: string | undefined = 'desc'
    let topics: string[] = []

    if (props.masthead === 'thenightly' || props.masthead === 'sevennews') {
        publishedSince = getPublishedSince(props.timeFilter, props.masthead)
        sort = getSortOrder(props.sortBy)

        const rawTopics = props.topic
            ? props.topic.split(',').filter((x) => x !== 'all')
            : []

        const rawLocations = props.location
            ? props.location.split(',').filter((x) => x !== 'all')
            : []

        const combinedTopics = [...rawTopics, ...rawLocations]
        if (combinedTopics.length > 0) {
            topics = combinedTopics
        }
    }

    try {
        const searchedPublications = await getSearchPublications(
            services,
            props.searchTerm,
            {
                ...props.options,
                publishedSince,
                paging: props.options.paging ?? { pageSize: 20 },
                sort,
                topics,
            },
        )

        const mappedListing = searchedPublications.documents.map(
            (listPublication) => mapListPublication(listPublication),
        )
        return {
            loadMorePossible: searchedPublications.morePublicationsAvailable,
            kind: 'listing',
            publications: mappedListing,
            total: searchedPublications.total,
        }
    } catch (err) {
        services.log.error(
            { err: err as Error, searchTerm: props.searchTerm },
            'Error loading search results',
        )
        return emptySearchListing()
    }
}
